import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { Header, Ad } from '../../../component';
import Page from '../../../lib/page';
import styles from './index.css';
import Info from './info';
import Comment from './comment';
import Recommend from './rec';
import QRCode from 'qrcode.react';
import wandu from '../../../service/wandu';
import env from '../../../lib/env';

export default class DetailPage extends Page {

    state = {
        info: {},
        newest_chapter: null,
        scroll_status: false
    }

    componentDidMount() {
        console.log('DetailPage', this.props.match.params);
        this._load(this.props.match.params.novel_id);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.match.params.novel_id !== this.props.match.params.novel_id) {
            this._load(nextProps.match.params.novel_id);
            return false;
        }
        return true;
    }

    _load = (novel_id) => {
        wandu.book_detail({ novel_id }).then(res => {
            if (!res.novel_info.novel_id) {
                env.goto_404();
                return;
            }
            this.setState({
                info: res.novel_info,
                newest_chapter: res.new_paragraph[0],
            });
            this.scroll_top();
        }).catch(e => {
            console.log(e);
            if (e.errno === 20001) {
                env.goto_404();
            }
        });
    }

    add_collect = () => {
        const { novel_id } = this.props.match.params;
        wandu.add_collect({ novel_id }).then(res => {
            this.state.info.in_bookshelf = true;
            this.setState({});
        }).catch(e => {
            console.log(e);
        });
    }

    handleScroll = (e) => {
        if (document.documentElement.scrollTop >= 1550) {
            this.setState({
                scroll_status: true
            })
        } else {
            this.setState({
                scroll_status: false
            })
        }
    }

    render() {
        return (
            <div className={styles.container}>
                <div className="block" style={{
                    background: '#F9F9F9',
                    border: '1px solid rgba(1,1,1,0)',
                    margin: '0 0 60px 0',
                }}>
                    <Info
                        add_collect={this.add_collect}
                        novel_id={this.props.match.params.novel_id}
                        {...this.state.info}
                    />
                </div>
                <Row type="flex" justify="space-between">
                    <Col className={"block " + styles.main_block}>
                        <Header title="最新章节：" em style={{ float: 'left', marginBottom: '0' }} />
                        {this.state.newest_chapter &&
                            <div className={styles.chapter}>
                                <span>{this.state.newest_chapter.title}</span>
                                <span>{moment(1000 * this.state.newest_chapter.update_time).format('YYYY-MM-DD HH:mm')}</span>
                            </div>
                        }
                    </Col>
                    {/* <Col className={"block " + styles.side_block}>
                        <QRCode
                            value="//m.wandu.cn/attention/appdownload?from=pc"
                            size={58}
                            style={{
                                position: 'absolute',
                                left: '30px',
                                top: '5px',
                            }} />
                        <a href='https://img.wandu.cn/fe/pc_download/download.html' target='_blank' rel="noopener noreferrer">
                            <span style={{
                                position: 'absolute',
                                right: '45px',
                                color: '#666',
                                top: '25px',
                            }}>客户端同步阅读&gt;</span>
                        </a>
                    </Col> */}
                </Row>
                {/* <Row type="flex" justify="space-between">
                    <Col className={styles.main_block}>
                        <div className="block"><Comment novel_id={this.props.match.params.novel_id} /></div>
                    </Col>
                    <Col className={styles.side}>
                        <Recommend
                            getBookRecLength={this.BookRecLength}
                            novel_id={this.props.match.params.novel_id}
                            type={this.state.info.type}
                        />
                    </Col>
                </Row> */}
                {this.state.scroll_status && <div id='read_right_menu' style={{
                    position: 'fixed',
                    right: '50%',
                    bottom: '154px',
                    marginRight: '-325px',
                    zIndex: '1'
                }}>
                    <div className={styles.right_menu} onClick={this.scroll_top}><img src='https://img.wandu.cn/novel/cover/2018-10-18/24536A89F920B377E19CF04C7FFC929E.png' alt='' /></div>
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/book/detail/index.js